<template>
    <div class="profile columns is-multiline mx-2">

        <settings-sidebar :active-menu-item="'profile'"
                          class="first column is-3 py-2 mr-md-3 mb-3 mb-md-auto">
        </settings-sidebar>
        <div class="second column mb-3 p-0" v-if="(user.eod_technician || user.technical_interest) && user.stripe_plan ">
            <cat-uxo-profile-supporter :user="user"></cat-uxo-profile-supporter>

            <cat-uxo-profile-change-password :user="user"></cat-uxo-profile-change-password>
        </div>

        <div class="second column mb-3 p-0" v-if="(user.eod_technician || user.technical_interest) && !user.stripe_plan ">
            <cat-uxo-profile-supporter :user="user"></cat-uxo-profile-supporter>

            <cat-uxo-profile-change-password :user="user"></cat-uxo-profile-change-password>
        </div>

        <div class="second column mb-3 p-0" v-if="(!user.stripe_plan && !user.eod_technician && !user.technical_interest) || (user.stripe_plan && !user.eod_technician && !user.technical_interest)">
            <cat-uxo-profile-advertisement :user="user"></cat-uxo-profile-advertisement>

            <cat-uxo-profile-change-password :user="user"></cat-uxo-profile-change-password>
        </div>

<!--        <div class="second column mb-3 p-0" v-if="!user.stripe_plan && !user.eod_tehnician && !user.technical_interest">-->
<!--            <h1 class="pb-4">You are not currently subscribed to any plans.</h1>-->
<!--            <p>Please contact <a href="mailto:hello@cat-uxo.com">hello@cat-uxo.com</a> or create a new account and subscribe to a plan.</p>-->
<!--        </div>-->
    </div>
</template>

<script>
    import SettingsSidebar from '../../shared/SettingsSidebar';
    import CatUxoProfileChangePassword from './ChangePassword';
    import {mapGetters} from "vuex";
    import {axiosApi, axiosWeb} from "@/js/axios";
    import {required, email} from 'vuelidate/lib/validators';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import CatUxoProfileSupporter from "./ProfileSupporter";
    import CatUxoProfileAdvertisement from "./ProfileAdvertisement";

    export default {
        name: 'CatUxoPageProfile',
        components: {
            CatUxoProfileAdvertisement,
            CatUxoProfileSupporter,
            SettingsSidebar,
            CatUxoProfileChangePassword,
            PulseLoader,
        },
        props: {
            user: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include media-breakpoint-down(sm) {
        .btn,
        .btn-form {
            width: 100%;
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/Profile.vue